export default __webpack_public_path__ + "static/media/roi.d2df0541.jpg";